import {
  Box,
  CircularProgress,
  Container,
  Grid,
  Typography,
} from "@mui/material";
import { useTextDomainContext } from "@/app/providers";
import React, { useContext } from "react";
import { useAllowRegistration, usePageTitle } from "@/hooks";
import { AuthPageLayout } from "@/pages/auth/components";
import { RegisterLinkSection } from "@/pages/auth/Register/RegisterLinkSection";
import { RegistrationForm } from "@/pages/auth/Register/RegistrationForm";
import { Link } from "react-router";

/**
 *
 */
export function Register() {
  const { TextDomainContext } = useTextDomainContext();
  const { gettext } = useContext(TextDomainContext);
  const { allowRegistration, loading } = useAllowRegistration();

  // Set page title
  usePageTitle(gettext("Register"));

  return (
    <AuthPageLayout>
      {/*<Navigate to="/auth/login" />*/}
      <Container sx={{ width: "100%" }}>
        {loading ? (
          <Box sx={{ display: "flex", justifyContent: "center", py: 8 }}>
            <CircularProgress size={32} />
          </Box>
        ) : !allowRegistration ? (
          <Grid container spacing={1} sx={{ width: "100%" }}>
            <Grid size={{ xs: 12 }}>
              <Typography variant="h2" sx={{ color: "grey.900" }}>
                {gettext("Sign up")}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }}>
              <Typography variant="h6" sx={{ color: "grey.900" }}>
                {gettext(
                  "This is a heads-up, everyone! We've temporarily paused new registrations. But don't worry, we'll open them again shortly. Stay tuned!",
                )}
              </Typography>
            </Grid>
            <Grid size={{ xs: 12 }} sx={{ mt: 2 }}>
              <Typography
                component={Link}
                to="/auth/login"
                sx={{
                  textDecoration: "none",
                  fontSize: 16,
                  fontWeight: 500,
                  color: "primary",
                }}
              >
                {gettext("Back to Sign in")}
              </Typography>
            </Grid>
          </Grid>
        ) : (
          <Grid container spacing={1} sx={{ width: "100%" }}>
            <Grid size={{ xs: 12 }}>
              {/*{gettext("The registration is by invitation only.")}*/}
              <RegistrationForm />
            </Grid>
            <Grid size={{ xs: 12 }}>
              <RegisterLinkSection />
            </Grid>
          </Grid>
        )}
      </Container>
    </AuthPageLayout>
  );
}
